import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'

import { useAutomationContextlessPolicies } from 'modules/automations/hooks/useAutomationContextlessPolicies'
import CollectionsBootstrap from 'modules/automations/lib/SettingsCollectionsBootstrap'
import { accessGroups as accessGroupsCollection } from 'modules/automations/store/collections/accessGroups'
import { actions as actionsCollection } from 'modules/automations/store/collections/actions'
import { automations as automationsCollection } from 'modules/automations/store/collections/automations'
import notifiersCollection from 'modules/automations/store/collections/notifiers'
import { operations as operationsCollection } from 'modules/automations/store/collections/operations'
import { triggers as triggersCollection } from 'modules/automations/store/collections/triggers'

const Container = () => {
  const { manageCustomNotifications } = useAutomationContextlessPolicies()
  const [loadingData, setLoadingData] = useState(true)

  useEffect(() => {
    async function loadData() {
      await Promise.all([
        accessGroupsCollection.fetch(),
        actionsCollection.fetch(),
        automationsCollection.fetch(),
        notifiersCollection.isEmpty ? notifiersCollection.fetch() : Promise.resolve(),
        operationsCollection.isEmpty ? operationsCollection.fetch() : Promise.resolve(),
        triggersCollection.isEmpty ? triggersCollection.fetch() : Promise.resolve(),
      ])
      setLoadingData(false)

      return true
    }

    loadData()
  }, [loadingData])

  if (loadingData) return <Loading />

  return (
    <AuthorizeUser authorizeFn={() => manageCustomNotifications}>
      <Outlet />
    </AuthorizeUser>
  )
}

const AutomationsRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default AutomationsRootPage
